export const GET_USERS = 'GET_USERS';
export const GET_USERS_STARTED = `${GET_USERS}_STARTED`;
export const GET_USERS_SUCCEED = `${GET_USERS}_SUCCEED`;
export const GET_USERS_FAILED = `${GET_USERS}_FAILED`;

export const INVITE_USER = 'INVITE_USER';
export const INVITE_USER_SUCCEED = `{INVITE_USER}_SUCCEED`;
export const INVITE_USER_FAILED = `{INVITE_USER}_FAILED`;

export const RESEND_INVITATION = 'RESEND_INVITATION';

export const CONFIRM_INVITED_USER = 'CONFIRM_INVITED_USER';
export const CONFIRM_INVITED_USER_SUCCEED = `${CONFIRM_INVITED_USER}_SUCCEED`;
export const CONFIRM_INVITED_USER_FAILED = `${CONFIRM_INVITED_USER}_FAILED`;

export const SUBMIT_USER_INVITATION = 'SUBMIT_USER_INVITATION';
export const SUBMIT_USER_INVITATION_SUCCEED = `${SUBMIT_USER_INVITATION}_SUCCEED`;
export const SUBMIT_USER_INVITATION_FAILED = `${SUBMIT_USER_INVITATION}_FAILED`;

export const GET_USER_COMPANIES = 'GET_USER_COMPANIES';
export const GET_USER_COMPANIES_STARTED = `${GET_USER_COMPANIES}_STARTED`;
export const GET_USER_COMPANIES_SUCCEED = `${GET_USER_COMPANIES}_SUCCEED`;
export const GET_USER_COMPANIES_FAILED = `${GET_USER_COMPANIES}_FAILED`;

export const GET_ROLES = 'GET_ROLES';
export const GET_ROLES_STARTED = `${GET_ROLES}_STARTED`;
export const GET_ROLES_SUCCEED = `${GET_ROLES}_SUCCEED`;
export const GET_ROLES_FAILED = `${GET_ROLES}_FAILED`;
